(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-custom"] && !Shopify.designMode) return;
  try {
    /* ────────────────────────────────────────────────────────────────────
   Rating widget relocator (ported from the Vitrine card)
   ────────────────────────────────────────────────────────────────────
   BK Reviews auto-injects its widget as a direct child of the product
   card root — meaning it lands as a sibling of .bbpc__link instead of
   next to the title, wherever its own script happens to append it.

   This snippet ships an empty .bbpc__rating slot between the title and
   the tagline/price. This script:
     1. On initial load, moves any non-structural direct child of .bbpc
        (= an auto-injected widget) into the slot.
     2. Uses MutationObserver to catch widgets that inject after page
        load AND newly-rendered cards from AJAX (quick-add, related
        products, infinite scroll).

   If BK Reviews honors the data-product-id / data-bk-* attributes on
   the slot and injects directly into it, this script does nothing
   (widget is already in the right place, not a direct child to
   relocate).

   Shared verbatim with the Vitrine card — the window.__bbpcRating...
   guard makes it safe if both snippets ever end up on the same page.
   ──────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__bbpcRatingRelocatorBound) return;
  window.__bbpcRatingRelocatorBound = true;

  var STRUCTURAL = ['bbpc__link', 'bbpc__btn', 'bbpc__btn--disabled', 'bbpc__form'];

  function isStructural(el) {
    if (!el.classList) return false;
    for (var i = 0; i < STRUCTURAL.length; i++) {
      if (el.classList.contains(STRUCTURAL[i])) return true;
    }
    return false;
  }

  function relocate(card) {
    var slot = card.querySelector('.bbpc__rating');
    if (!slot) return;
    Array.prototype.slice.call(card.children).forEach(function (child) {
      if (!isStructural(child)) slot.appendChild(child);
    });
  }

  function relocateAll(root) {
    (root || document).querySelectorAll('.bbpc').forEach(relocate);
  }

  function init() {
    relocateAll();

    // Catches async-loaded widgets AND AJAX-loaded cards
    var obs = new MutationObserver(function (muts) {
      var cards = new Set();
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // text nodes etc.
          if (node.classList && node.classList.contains('bbpc')) {
            cards.add(node);
          } else if (node.closest) {
            var card = node.closest('.bbpc');
            if (card) cards.add(card);
          }
        });
      });
      cards.forEach(relocate);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
